import * as React from 'react'
function SvgBug(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M35.118 22.824v-3.765h-3.765a14.955 14.955 0 00-1.13-4.141l3.765-3.2-2.447-2.824-3.388 2.824-1.694-1.694C26.647 7.2 23.447 4 20.059 4c-3.388 0-6.588 3.2-6.588 6.024-.565.564-1.13.94-1.695 1.694l-3.2-2.824-2.447 2.824 3.765 3.2a14.955 14.955 0 00-1.13 4.14H5v3.766h3.765c.188 1.882.94 3.764 1.694 5.458l-3.012 2.636 2.447 2.823 2.824-2.447c1.882 1.882 4.517 3.012 7.153 3.012 2.635 0 5.27-1.13 7.153-3.012l2.823 2.447 2.447-2.823-3.012-2.636c1.318-1.694 1.883-3.576 2.07-5.458h3.766z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgBug
